import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const IMG = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80`;

const CELLS = [
  { key: "bureau", title: "Bureau", sub: "Bureau assis-debout, supports, carnets, clavier et souris.", img: IMG("1510519138101-570d1dca3d66"), cls: "md:col-span-7" },
  { key: "cuisine", title: "Cuisine", sub: "Machines à café, bouilloires, ustensiles et rangement.", img: IMG("1785535573636-42450fa4cecb"), cls: "md:col-span-5" },
  { key: "maisonjardin", title: "Maison & Jardin", sub: "Déco, coussins, vases et outils de jardinage.", img: IMG("1761330439252-325f2091e88d"), cls: "md:col-span-5" },
  { key: "bazar", title: "Bazar", sub: "Idées cadeaux, gadgets, voyage, jeux : un peu de tout.", img: IMG("1468495244123-6c6c332eeece"), cls: "md:col-span-7" },
];

const Cell = ({ c, onPick, i, count }) => (
  <Reveal delay={i * 0.1} className={`h-80 md:h-auto ${c.cls}`}>
    <button data-testid={`bento-collection-${c.key}`} onClick={() => onPick(c.key)}
      className="group relative block h-full w-full overflow-hidden rounded-[22px] bg-[var(--ink)] text-left">
      <motion.img src={c.img} alt={c.title} className="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-[1.4s] ease-out group-hover:scale-[1.07]" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
      {count > 0 && <div className="absolute left-6 top-6 rounded-full bg-[#FBF9F5]/90 px-3 py-1 font-mono-label text-[10px] text-[var(--ink)] backdrop-blur">{String(count).padStart(2, "0")} sélections</div>}
      <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between gap-6 p-6 sm:p-8 text-[var(--bone)]">
        <div>
          <h3 className="font-display text-3xl sm:text-4xl font-light leading-tight">{c.title}</h3>
          <p className="mt-2 max-w-sm text-sm text-[#EDE6DA]">{c.sub}</p>
        </div>
        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-[#FBF9F5]/60 transition-[background-color,color,transform] duration-500 group-hover:rotate-45 group-hover:bg-[var(--bone)] group-hover:text-[var(--ink)]">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>
    </button>
  </Reveal>
);

export const Bento = ({ onPick, products = [] }) => (
  <section id="collections" data-testid="bento-collections" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-10 sm:py-32">
    <div className="mb-14 grid gap-6 md:grid-cols-12">
      <Reveal className="md:col-span-7">
        <Eyebrow>(01) — Collections</Eyebrow>
        <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02] tracking-tight">
          Tout pour la maison, <em className="italic text-[var(--terra)]">une même</em> exigence.
        </h2>
      </Reveal>
      <Reveal delay={0.15} className="md:col-span-4 md:col-start-9 self-end">
        <p className="text-base leading-relaxed text-[var(--muted)]">
          Nous comparons, nous sélectionnons, et nous vous envoyons chez le marchand. Vous achetez au prix du marchand, sans aucun surcoût.
        </p>
      </Reveal>
    </div>
    <div className="grid grid-cols-1 gap-4 md:h-[680px] md:grid-cols-12 md:grid-rows-2">
      {CELLS.map((c, i) => <Cell key={c.key} c={c} i={i} onPick={onPick} count={products.filter((p) => p.collection === c.key).length} />)}
    </div>
  </section>
);
